import { useIsMobile } from '@cp/ds/src/hooks/useIsMobile';
import { Accordion } from '@cp/ds/src/components/accordion';
import React from 'react';

export const StateList: React.FC<{ title: React.ReactNode; content: React.ReactNode }> = (props) => {
  const { title, content } = props;
  const isMobile = useIsMobile();
  return isMobile ? (
    <Accordion
      details={content}
      detailsId={`state-list-details-${title}`}
      detailsSx={{ px: 0 }}
      summary={title}
      summaryId={`state-list-summary-${title}`}
      summarySx={{ position: 'relative', alignItems: 'center', color: 'brand gray', px: 0 }}
    />
  ) : (
    <>
      {title}
      {content}
    </>
  );
};
